export { postHaptisch, postDigital, postGuthaben };

const WARENKORB_HAPTISCH = "/api/geschenkkarte/warenkorb/haptisch";
const WARENKORB_DIGITAL = "/api/geschenkkarte/warenkorb/digital";
const GUTHABEN = "/api/geschenkkarte/guthaben/";

/**
 *
 * @param {AddHaptischeGkToWarenkorb} data
 * @returns {Promise<Response>}
 */
async function postHaptisch(data) {
  return rejectOnError(postFetch(WARENKORB_HAPTISCH, data, 20000));
}

/**
 *
 * @param {AddDigitaleGkToWarenkorb} data
 * @returns {Promise<Response>}
 */
async function postDigital(data) {
  return rejectOnError(postFetch(WARENKORB_DIGITAL, data, 20000));
}

/**
 *
 * @param {GeschenkkarteDaten} data
 * @returns {Promise<Response>}
 */
async function postGuthaben(data) {
  return rejectOnError(postFetch(GUTHABEN, data, 20000));
}


export function redirectToWarenkorb(submitUrl, postObject) {
  const keys = Object.keys(postObject);

  const form = document.createElement("form");
  form.method = "POST";
  form.action = submitUrl;

  keys.forEach((key) => {
    const value = postObject[key];
    const input = document.createElement("input");
    input.name = key;
    input.value = value;
    input.hidden = true;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
}

/**
 * @param {string} url
 * @param {*} payload
 * @param {number=} timeout
 * @returns {Promise<Response>}
 */
async function postFetch(url, payload, timeout) {
  // const xsrfToken = getCookieByName(XSRF_TOKEN_NAME);
  // const xsrfHeaderKey = `X-${XSRF_TOKEN_NAME}`;

  /** @type {RequestInit} */
  const paramPost = {
    credentials: "same-origin",
    method: "POST",
    signal: getSignal(timeout),
    headers: {
      "Content-Type": "application/json",
      //  [xsrfHeaderKey]: xsrfToken,
      "X-Requested-With": "XMLHttpRequest"
    },
    body: JSON.stringify(payload)
  };

  return fetch(url, paramPost);
}

/**
 * @param {string} url
 * @param {number=} timeout
 * @returns {Promise<Response>}
 */
async function _getFetch(url, timeout) {
  /** @type {RequestInit} */
  const paramGet = {
    credentials: "include",
    method: "GET",
    signal: getSignal(timeout),
    mode: "no-cors"
  };

  return fetch(url, paramGet);
}

/**
 * @param {Promise<Response>} response
 * @return {Promise<Response>}
 */
async function rejectOnError(response) {
  const res = await response;
  if (!res.ok) {
    return Promise.reject(res);
  }

  return response;
}

/**
 * @param {number} timeout in ms
 * @return {AbortSignal}
 */
function getSignal(timeout) {
  let timeoutSignal;
  if (timeout) {
    const timeoutAbortController = new AbortController();
    setTimeout(() => {
      return timeoutAbortController.abort(); 
    }, timeout);
    timeoutSignal = timeoutAbortController.signal;
  }
  return timeoutSignal;
}
